import React from 'react';

import Form from '@atlaskit/form';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';

import { useAudioBriefing } from '../../../../hooks/useAudioBriefing';
import type { CustomLengthType, CustomToneType } from '../../../../types/customizationTypes';
import { CustomizePanelRestartButton } from '../../sub-components/RestartButton';

import { ToneSelector } from './ToneSelector';
import { DurationSelector } from './DurationSelector';

const styles = cssMap({
	grow: {
		flex: 1,
	},
	buttonWrapper: {
		paddingBlockStart: token('space.150'),
	},
});

interface CustomizationFormValues {
	length: CustomLengthType;
	tone: {
		value: CustomToneType;
	};
}

export const AudioBriefingPopupCustomizePanel = ({
	audioRef,
}: {
	audioRef: React.RefObject<HTMLAudioElement>;
}) => {
	const [{ hasFetched, isLoading }] = useAudioBriefing();

	return (
		<Box xcss={styles.grow}>
			<Form<CustomizationFormValues> onSubmit={() => {}}>
				{({ formProps }) => (
					<form {...formProps}>
						<Stack space="space.100">
							<ToneSelector />
							<DurationSelector />
							{hasFetched && (
								<Box xcss={styles.buttonWrapper}>
									<CustomizePanelRestartButton audioRef={audioRef} isLoading={isLoading} />
								</Box>
							)}
						</Stack>
					</form>
				)}
			</Form>
		</Box>
	);
};
